export default __webpack_public_path__ + "event_schedule_app.png";